import { createSelector } from "reselect"
import { chain, get, isUndefined } from "lodash"
import { getIsActive, getPortfolio } from "modules/portfolio-root/selectors/portfolios"
import { getLastRefresh } from "modules/intraday/selectors"

const getIntradayAsOfState = state => get(state, "modules.rebalance.intradayAsOf")

export const getRawIntradayBatchId = state => get(state, "modules.rebalance.intradayBatchId")
export const getIsIntradayRebalance = state => get(state, "modules.rebalance.isIntradayRebalance")
export const getIsIntradayRoute = () => chain(window.location)
  .get("pathname")
  .split("/")
  .takeRight(2)
  .join("/")
  .value() === "intraday/simulator"

export const getIsIntraday = createSelector(
  [getPortfolio, getIsIntradayRoute],
  (portfolio, intradayRoute) => get(portfolio, "intradayEnabled") && intradayRoute,
)

export const getIntradayAsOf = createSelector(
  [getIntradayAsOfState, getLastRefresh],
  (asOfState, lastRefresh) => isUndefined(asOfState) ? lastRefresh : asOfState,
)

export const getIsActiveAndNotIntraday = createSelector(
  [getIsActive, getIsIntraday],
  (isActive, isIntraday) => isActive && !isIntraday,
)

export const getIntradayBatchId = createSelector(
  [getRawIntradayBatchId, getIsIntraday],
  (batchId, isIntraday) => isIntraday ? batchId : undefined,
)

export const getIntradayRefreshable = createSelector(
  [getIntradayAsOfState, getLastRefresh],
  (intradayAsOf, lastRefresh) => intradayAsOf !== lastRefresh,
)
